import type { SVGProps } from 'react';
export const AccountStatusDeclined = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 10 10" {...props}>
    <path
      fill="#D41D11"
      d="M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0m4.23 5c0 .99-.35 1.95-.98 2.7L2.29 1.76A4.23 4.23 0 0 1 9.23 5M.77 5c0-.99.35-1.95.98-2.7l5.96 5.95A4.23 4.23 0 0 1 .77 5"
    />
  </svg>
);
